import { createGlobalStyle } from "styled-components";
import nav from "./main/nav";
import responsive from "./main/responsive";

const Style = createGlobalStyle`
body {
	background: #fff;
}
.hideSection {
    display:none;
}
${nav}
${responsive}
`;

export default Style;
